import React from "react";
import { useFormikContext } from "formik";
import { usePendingPrefill, useSetDefaultValue } from "../../hooks";
import { emptyFunction } from "../../utils/helpers/emptyFunction";
import { isUndefined } from "../../utils/helpers/typeHelper";
import { Select } from "./select";

function getFirstValue(options) {
  const { value = "" } = (options && options[0]) || {};
  return value;
}

const getSelectDefaultOption = (options, placeholder) => {
  return isUndefined(placeholder) ? getFirstValue(options) : "";
};

export const PrefillSelect = (props) => {
  const {
    name, title, placeholder, prefix, toolTipText, className, onBlur, options, isLoading
  } = props;
  const { handleChange, handleBlur, values, errors, touched } = useFormikContext();

  useSetDefaultValue(name, getSelectDefaultOption(options, placeholder), isLoading);
  usePendingPrefill(name);

  return (
    <Select
      title={title}
      placeholder={placeholder}
      onChange={handleChange}
      onBlur={(event) => {
        handleBlur(event);
        (onBlur || emptyFunction)(event);
      }}
      value={values[name]}
      options={options}
      name={name}
      prefix={prefix}
      toolTipText={toolTipText}
      className={className}
      errorMessage={touched[name] ? errors[name] : ""}
      handleChange={handleChange}
    />
  );
};